import {
  GetUnacknowledgedPlatformNotificationsListType,
  NotificationListType,
} from "./notificationsApi";

export const notificationsCategories = [
  "OPERATIONS",
  "FRAUD",
  "TRANSACTIONS",
  "MAINTENANCE",
  "DRIVING_BEHAVIOR",
  "BALANCE_AND_BILLING",
];

export const notifications = [
  "NEW_DRIVER_CREATED",
  "DRIVER_ROTATION_REQUEST",
  "NO_DRIVER",
  "MILEAGE_OVER_15_PERCENT_COMPARED_TO_PLANNING",
  "VEHICLE_OVER_DRIVING_MONTHLY",
  "VEHICLE_UNDER_DRIVING_MONTHLY",
  "VEHICLE_REQUIRING_TECHNICAL_INSPECTION",
  "TIRE_PRESSURE_ALERT",
  "NEXT_MAINTENANCE_ALERT",
  "DASHBOARD_WARNING",
  "SUSPICIOUS_CONSUMPTION_DETECTED",
  "TANK_CAPACITY_REACHED_95_PERCENT",
  "TANK_CAPACITY_REACHED_100_PERCENT",
  "WEEKEND_TRANSACTIONS",
  "VEHICLE_MOVING_AFTER_7_PM",
  "VEHICLE_MOVING_ON_WEEKENDS_OR_PUBLIC_HOLIDAYS",
  "VEHICLE_EXCEEDING_SPEED_LIMITS",
  "ECO_DRIVING_SCORE_UNDER_30",
  "LOSS_SCORE_UNDER_30",
  "MISSING_SUPPORTING_DOCUMENT",
  "MISSING_MILEAGE",
  "CARD_EXCEEDED_LIMIT_REACHED",
  "CARD_EXCEEDED_LIMIT_REACHED_80_PERCENT",
  "UNAUTHORIZED_MERCHANT",
  "UNAUTHORIZED_PERIOD",
  "ACCOUNT_BALANCE_UNDER_30",
  "INSUFFICIENT_BALANCE",
  "NEW_TRANSACTION_CREATED",
];

export const notificationsList: NotificationListType[] = [
  {
    category: "OPERATIONS",
    type: "NEW_DRIVER_CREATED",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "OPERATIONS",
    type: "DRIVER_ROTATION_REQUEST",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },

  {
    category: "OPERATIONS",
    type: "NO_DRIVER",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "OPERATIONS",
    type: "MILEAGE_OVER_15_PERCENT_COMPARED_TO_PLANNING",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "OPERATIONS",
    type: "VEHICLE_OVER_DRIVING_MONTHLY",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "OPERATIONS",
    type: "VEHICLE_UNDER_DRIVING_MONTHLY",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "MAINTENANCE",
    type: "VEHICLE_REQUIRING_TECHNICAL_INSPECTION",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "MAINTENANCE",
    type: "TIRE_PRESSURE_ALERT",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "MAINTENANCE",
    type: "NEXT_MAINTENANCE_ALERT",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "MAINTENANCE",
    type: "DASHBOARD_WARNING",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },

  {
    category: "FRAUD",
    type: "SUSPICIOUS_CONSUMPTION_DETECTED",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "FRAUD",
    type: "TANK_CAPACITY_REACHED_95_PERCENT",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "FRAUD",
    type: "TANK_CAPACITY_REACHED_100_PERCENT",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "FRAUD",
    type: "WEEKEND_TRANSACTIONS",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "FRAUD",
    type: "VEHICLE_MOVING_AFTER_7_PM",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "FRAUD",
    type: "VEHICLE_MOVING_ON_WEEKENDS_OR_PUBLIC_HOLIDAYS",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "DRIVING_BEHAVIOR",
    type: "VEHICLE_EXCEEDING_SPEED_LIMITS",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "DRIVING_BEHAVIOR",
    type: "ECO_DRIVING_SCORE_UNDER_30",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "DRIVING_BEHAVIOR",
    type: "LOSS_SCORE_UNDER_30",
    isPlatformNotificationVisible: false,
    isOwnerEmailNotificationVisible: false,
    isAdminEmailNotificationVisible: false,
    isUserEmailNotificationVisible: false,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "MISSING_SUPPORTING_DOCUMENT",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "MISSING_MILEAGE",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "CARD_EXCEEDED_LIMIT_REACHED",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "CARD_EXCEEDED_LIMIT_REACHED_80_PERCENT",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "UNAUTHORIZED_MERCHANT",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "UNAUTHORIZED_PERIOD",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "NEW_TRANSACTION_CREATED",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  {
    category: "TRANSACTIONS",
    type: "BAD_FUEL",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
  // {
  //   category: "BALANCE_AND_BILLING",
  //   type: "ACCOUNT_BALANCE_UNDER_30",
  //   isPlateformNotificationVisible: false,
  //   isOwnerEmailNotificationVisible: false,
  //   isAdminEmailNotificationVisible: false,
  //   isUserEmailNotificationVisible: false,
  //   platformNotificationUuid: null,
  //   ownerEmailNotificationUuid: null,
  //   adminEmailNotificationUuid: null,
  //   userEmailNotificationUuid: null,
  // },
  {
    category: "BALANCE_AND_BILLING",
    type: "INSUFFICIENT_BALANCE",
    isPlatformNotificationVisible: true,
    isOwnerEmailNotificationVisible: true,
    isAdminEmailNotificationVisible: true,
    isUserEmailNotificationVisible: true,
    platformNotificationUuid: null,
    ownerEmailNotificationUuid: null,
    adminEmailNotificationUuid: null,
    userEmailNotificationUuid: null,
  },
];

export const fakeNotificationsByCategoriesDisplayedForDemo: GetUnacknowledgedPlatformNotificationsListType[] =
  [
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753094",
      type: "NO_DRIVER",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Aucun conducteur trouvé",
      description:
        "Aucun conducteur trouvé pour la transaction f1348c95-dd12-4744-a995-7c85e352f340 effectuée le 27/05/25.",
      actionPath:
        "/home/transactions/cards/f1348c95-dd12-4744-a995-7c85e352f340",
      createdAt: "2024-04-06 09:50:00.000 +0200",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753095",
      type: "NEW_TRANSACTION_CREATED",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Nouvelle transaction effectuée",
      description:
        "John Doe a effectué une nouvelle transaction avec le véhicule EZ-133-EE le 02/06/25.",
      actionPath:
        "/home/transactions/cards/2d7d2e88-cf58-4328-ad25-5aed488ca471",
      createdAt: "2024-06-19 11:11:00.000 +0200",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753097",
      type: "TANK_CAPACITY_REACHED_95_PERCENT",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Un plein de carburant semble suspect",
      description:
        "Un plein sur le véhicule ST-456-UV a dépassé 95% de la capacité de son réservoir le 27/05/25.",
      actionPath:
        "/home/transactions/cards/34561386-bfd6-4c07-b6cb-9c5f4bfa99c6",
      createdAt: "2024-03-14 09:10:00.000 +0100",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753098",
      type: "VEHICLE_MOVING_AFTER_7_PM",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Véhicule en déplacement après 19h",
      description:
        "Le véhicule portant le numéro d’identification (VIN) VF1RJA00770442002 est en déplacement depuis le 07/05/28 à 20h56.",
      actionPath: "/home/vehicles/8ee98027-7e54-45ec-8a6a-6094b9367cb0",
      createdAt: "2025-05-07 20:56:00.000 +0200",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753099",
      type: "UNAUTHORIZED_MERCHANT",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Marchand non autorisé",
      description:
        "John Doe a effectué une dépense avec le véhicule ST-456-UV le 02/06/25 dans une station dont le marchand n'est pas autorisé.",
      actionPath:
        "/home/transactions/cards/550f8526-d0e6-4064-b036-0127d732f709",
      createdAt: "2025-02-02 08:50:00.000 +0100",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753100",
      type: "ECO_DRIVING_SCORE_UNDER_30",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Score d’éco-conduite inférieur à 30",
      description:
        "Le véhicule portant le numéro d’identification (VIN) VF1RJA00770442002 a obtenu le score d'éco-conduite 24.3 lors d’un trajet effectué entre le 10/05/25 à 15h16 et le 10/05/25 à 15h32.",
      actionPath: "/home/vehicles/8ee98027-7e54-45ec-8a6a-6094b9367cb0",
      createdAt: "2025-06-10 16:23:54.165 +0200",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753101",
      type: "MISSING_SUPPORTING_DOCUMENT",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Justificatif manquant",
      description:
        "John Doe n'a toujours pas transmis de justificatif pour la transaction chez Rocket Rides de 10€, effectuée le 02/06/25.",
      actionPath:
        "/home/transactions/cards/d59ddfa7-289b-465d-951c-5d0c810fb3a6",
      createdAt: "2024-03-10 12:40:00.000 +0100",
    },
    {
      uuid: "6256a7b4-6268-461e-ad6d-fa6524753110",
      type: "UNAUTHORIZED_PERIOD",
      company: "c241e112-881b-4b15-a276-036491e74951",
      title: "Période non autorisée",
      description:
        "John Doe a effectué une dépense avec le véhicule BB-444-BB le 30/05/25 lors d'une période non autorisée.",
      actionPath:
        "/home/transactions/cards/d59ddfa7-289b-465d-951c-5d0c810fb3a6",
      createdAt: "2025-05-30 16:29:43.385 +0200",
    },
  ];
